export interface ArticleItem {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  contentHtml: string;
  coverImage: string;
  category: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
  isFeatured: boolean;
}

export const articles: ArticleItem[] = [
  {
    id: 'a1',
    title: '2024年最值得期待的十部国产剧，每一部都是王炸',
    slug: '2024-top-10-chinese-dramas',
    excerpt: '盘点2024年即将播出的十部重磅国产剧，从古装权谋到现代悬疑，从科幻巨制到温情家庭剧，部部精彩不容错过。',
    contentHtml: `
      <p>2024年国产剧市场可谓是百花齐放，各大平台纷纷拿出了压箱底的好剧。今天我们就来盘点一下今年最值得期待的十部国产剧。</p>
      <h2>一、《庆余年2》</h2>
      <p>时隔五年，范闲终于回来了。原班人马回归，张若昀、李沁、陈道明等实力派演员继续出演。第二季剧情将更加跌宕起伏，范闲的身世之谜也将逐步揭开。</p>
      <h2>二、《大奉打更人》</h2>
      <p>改编自卖报小郎君同名小说，王鹤棣、田曦薇主演。讲述现代警校毕业生许七安穿越到大奉王朝，成为打更人破案的故事。</p>
      <h2>三、《狐妖小红娘·月红篇》</h2>
      <p>杨幂、龚俊主演的古装仙侠剧，改编自同名热门动漫。精美的服化道和宏大的世界观设定，让人充满期待。</p>
      <h2>四、《繁花》</h2>
      <p>王家卫导演的首部电视剧，胡歌、马伊琍、唐嫣主演。以上世纪九十年代的上海为背景，讲述阿宝的奋斗故事。</p>
      <h2>五、《藏海传》</h2>
      <p>肖战、张婧仪主演的古装权谋剧，改编自南派三叔小说。盗墓笔记宇宙的又一力作。</p>
      <p>以上只是冰山一角，2024年的国产剧市场精彩纷呈，你最期待哪一部呢？</p>
    `,
    coverImage: 'https://readdy.ai/api/search-image?query=Cinematic%20collage%20of%20Chinese%20historical%20drama%20scenes%2C%20ancient%20costumes%2C%20palace%20interiors%2C%20dramatic%20lighting%2C%20movie%20poster%20style%20composition%2C%20rich%20colors%2C%20epic%20scale%2C%20professional%20film%20photography&width=1200&height=600&seq=taohua-a1&orientation=landscape',
    category: '影视资讯',
    author: '影视观察员',
    publishDate: '2024-07-28',
    readTime: '8分钟',
    tags: ['国产剧', '2024', '剧集推荐'],
    isFeatured: true,
  },
  {
    id: 'a2',
    title: '深度解析《三体》：从小说到荧幕的完美蜕变',
    slug: 'three-body-problem-analysis',
    excerpt: '《三体》电视剧自播出以来引发广泛讨论，本文将从改编策略、视觉效果、演员表现等多角度深度解析这部科幻巨制。',
    contentHtml: `
      <p>《三体》电视剧的播出，可以说是中国科幻影视的一个里程碑。刘慈欣的原著小说获奖无数，将这样一部宏大的作品搬上荧幕，难度可想而知。</p>
      <h2>改编策略：忠于原著，适度创新</h2>
      <p>剧版《三体》在改编上采取了非常稳妥的策略——最大程度地忠实于原著。从汪淼看到倒计时，到进入三体游戏，再到古筝行动，每一个经典场景都被精心还原。同时，剧中适当加入了一些原创内容，比如对叶文洁青年时期的扩充描写，让人物更加丰满。</p>
      <h2>视觉效果：国产科幻的新高度</h2>
      <p>三体游戏中的场景设计堪称惊艳。脱水浸泡、人列计算机、三日凌空等概念被视觉化呈现，效果令人震撼。虽然与好莱坞顶级科幻片相比仍有差距，但在国产剧中已经达到了相当高的水准。</p>
      <h2>演员表现：老戏骨撑起半边天</h2>
      <p>张鲁一饰演的汪淼，于和伟饰演的史强，陈瑾和王子文分别饰演的老年和青年叶文洁，都贡献了教科书级别的表演。尤其是陈瑾老师的叶文洁，那种经历了巨大创伤后的冷静与决绝，令人不寒而栗。</p>
      <p>总的来说，《三体》电视剧是一部诚意满满的改编作品，为中国科幻影视树立了新的标杆。</p>
    `,
    coverImage: 'https://readdy.ai/api/search-image?query=Cosmic%20scale%20sci-fi%20scene%20with%20three%20suns%20in%20alien%20sky%2C%20strange%20planet%20surface%2C%20mysterious%20ancient%20civilization%20ruins%2C%20cinematic%20lighting%2C%20epic%20scale%2C%20thought-provoking%20atmosphere%2C%20deep%20space%20background&width=1200&height=600&seq=taohua-a2&orientation=landscape',
    category: '深度解析',
    author: '科幻迷小陈',
    publishDate: '2024-07-25',
    readTime: '12分钟',
    tags: ['三体', '科幻', '剧评'],
    isFeatured: true,
  },
  {
    id: 'a3',
    title: '从《狂飙》到《漫长的季节》：国产悬疑剧的黄金时代',
    slug: 'chinese-crime-drama-golden-age',
    excerpt: '近两年国产悬疑剧佳作频出，从《狂飙》到《漫长的季节》，我们正在见证国产悬疑剧的黄金时代。',
    contentHtml: `
      <p>如果说前几年是国产悬疑剧的起步期，那么这两年就是爆发期。《隐秘的角落》《沉默的真相》《狂飙》《漫长的季节》，几乎每一部都引发了全民讨论。</p>
      <h2>《狂飙》：扫黑除恶的史诗</h2>
      <p>《狂飙》讲述了安欣与高启强二十年的正邪较量。张颂文饰演的高启强从一个鱼贩成长为黑恶势力头目，其人物弧光令人印象深刻。这部剧最大的成功在于，它不只是简单的好人抓坏人的故事，而是深入探讨了人性的复杂。</p>
      <h2>《漫长的季节》：悬疑外壳下的人间悲欢</h2>
      <p>导演辛爽用三个时间线交织叙事，讲述了一个跨越二十年的悬疑故事。范伟贡献了演艺生涯中最好的表演之一，将一个失去儿子的父亲演得令人心碎。</p>
      <h2>国产悬疑剧的未来</h2>
      <p>好的悬疑剧不仅仅是破案，更重要的是呈现人性。期待未来有更多像《漫长的季节》这样既有悬疑张力又有人文关怀的作品。</p>
    `,
    coverImage: 'https://readdy.ai/api/search-image?query=Noir%20style%20Chinese%20city%20street%20at%20dusk%2C%20rain-slicked%20roads%2C%20neon%20signs%20reflecting%2C%20mysterious%20silhouette%20under%20streetlamp%2C%20crime%20drama%20atmosphere%2C%20cinematic%20composition%2C%20deep%20contrast%20lighting&width=1200&height=600&seq=taohua-a3&orientation=landscape',
    category: '深度解析',
    author: '影视观察员',
    publishDate: '2024-07-20',
    readTime: '10分钟',
    tags: ['悬疑剧', '狂飙', '漫长的季节'],
    isFeatured: true,
  },
  {
    id: 'a4',
    title: '动漫爱好者必看：国产动漫的崛起之路',
    slug: 'chinese-animation-rise',
    excerpt: '从《大圣归来》到《中国奇谭》，国产动漫用实力证明了中国动画人的创造力和想象力。',
    contentHtml: `
      <p>曾几何时，国产动漫还是"低幼"的代名词。但近年来，一批优秀的国产动漫作品彻底改变了这一刻板印象。</p>
      <h2>电影领域的突破</h2>
      <p>2015年《大圣归来》以9.56亿票房证明了国产动画电影的票房潜力。之后的《哪吒之魔童降世》更是以50亿票房创造历史。这些作品的成功，不仅在于精良的制作，更在于找到了中国传统文化与现代叙事的平衡点。</p>
      <h2>番剧领域的百花齐放</h2>
      <p>《斗罗大陆》《凡人修仙传》《一念永恒》等网文改编动画持续输出优质内容。《中国奇谭》则用多元美术风格征服了观众，证明国产动画同样可以做到艺术与商业的统一。</p>
      <h2>未来展望</h2>
      <p>随着技术积累和人才成长，国产动漫正在走向更加成熟的阶段。我们有理由相信，中国动画的黄金时代才刚刚开始。</p>
    `,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20style%20art%20scene%2C%20mythical%20dragon%20soaring%20through%20clouds%2C%20vibrant%20colors%2C%20traditional%20Chinese%20painting%20influence%2C%20dynamic%20composition%2C%20magical%20atmosphere%2C%20epic%20fantasy%20illustration&width=1200&height=600&seq=taohua-a4&orientation=landscape',
    category: '影视资讯',
    author: '动漫达人阿飞',
    publishDate: '2024-07-15',
    readTime: '7分钟',
    tags: ['国产动漫', '动画电影', '番剧'],
    isFeatured: false,
  },
  {
    id: 'a5',
    title: '纪录片推荐：足不出户看遍大千世界',
    slug: 'documentary-recommendations',
    excerpt: '精选五部高质量纪录片，涵盖自然、历史、美食等多个题材，带你足不出户领略世界的精彩。',
    contentHtml: `
      <p>纪录片是一扇窗，让我们能够看到世界的不同面貌。今天就为大家推荐几部近期不容错过的优秀纪录片。</p>
      <h2>一、《航拍中国》第四季</h2>
      <p>这是一部让人热泪盈眶的纪录片。当你从空中俯瞰祖国的大好河山，那种震撼无法用言语形容。每一帧都是一幅绝美的画卷。</p>
      <h2>二、《舌尖上的中国》系列</h2>
      <p>美食纪录片的巅峰之作。不只讲食物，更讲人与食物之间的情感连接，讲述普通中国人的生活故事。</p>
      <h2>三、《我在故宫修文物》</h2>
      <p>走近故宫深处的文物修复师，看他们如何用匠心让千年文物重现光彩。这是一部关于时间、技艺与传承的纪录片。</p>
      <h2>四、《人间世》</h2>
      <p>聚焦医院里的人间百态，记录生命的脆弱与坚强。每一集都让人深思生命的意义。</p>
      <h2>五、《绿色星球》</h2>
      <p>BBC出品，大卫·爱登堡解说。用延时摄影技术展现植物世界的精彩，让你看到一个不一样的绿色世界。</p>
    `,
    coverImage: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20landscape%20photography%20of%20Earth%2C%20dramatic%20natural%20wonders%2C%20mountains%20and%20oceans%2C%20documentary%20style%20cinematography%2C%20golden%20hour%20lighting%2C%20vast%20scale%2C%20breathtaking%20vista&width=1200&height=600&seq=taohua-a5&orientation=landscape',
    category: '影视资讯',
    author: '纪录片控小王',
    publishDate: '2024-07-10',
    readTime: '6分钟',
    tags: ['纪录片', '自然', '推荐'],
    isFeatured: false,
  },
];

export const getArticleBySlug = (slug: string): ArticleItem | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getFeaturedArticles = (): ArticleItem[] => {
  return articles.filter((a) => a.isFeatured);
};

export const getLatestArticles = (count: number = 3): ArticleItem[] => {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, count);
};